export const title = 'Users with notifications enabled';

{/* Content TBD */}
